import { Box, Button, Container, Typography } from '@mui/material'
import NotificationSys from 'components/NotificationSystem'
import { useQuery } from 'react-query'
import { unsubscribeEmail } from 'api/profile'
import { useSearchParamsObject } from 'utils/url'
import { useNavigate } from 'react-router-dom'
import { routes } from 'routes/routes'
import LoadingPlaceholder from 'components/placeholders/LoadingPlaceholder'
import { AuthCopyright } from '../AuthCopyright/AuthCopyright'

export const AuthPageUnsubscribeEmail = () => {
  const { token } = useSearchParamsObject()
  const navigate = useNavigate()

  const { isLoading, isSuccess, isError } = useQuery(
    ['unsubscribeEmail', token],
    () => unsubscribeEmail(token),
    {
      onSuccess: () => {
        NotificationSys.showSuccess(`Email unsubscribed successfully`)
      },
    },
  )

  const handleGoToHome = () => {
    navigate(routes.signIn)
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100vh"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        flex={1}
      >
        {isLoading && <LoadingPlaceholder />}

        {isSuccess && (
          <>
            <Typography variant="h5" textAlign="center" color="success.main" mb={3}>
              You have been successfully unsubscribed from email notifications.
            </Typography>
            <Button variant="contained" onClick={handleGoToHome} sx={{ minWidth: 160 }}>
              Go to Home
            </Button>
          </>
        )}

        {isError && (
          <>
            <Typography variant="h5" textAlign="center" color="error.main" mb={3}>
              Failed to unsubscribe. Please try again or contact support.
            </Typography>
            <Button variant="contained" onClick={handleGoToHome} sx={{ minWidth: 160 }}>
              Go to Home
            </Button>
          </>
        )}
      </Box>

      <Box mt="auto" mb={3}>
        <AuthCopyright />
      </Box>
    </Box>
  )
}
